import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", style }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    style={style}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "", inner = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block ${inner}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
